import { render, staticRenderFns } from "./AppLauncherInitializer.vue?vue&type=template&id=2c4dd31f"
import script from "./AppLauncherInitializer.vue?vue&type=script&lang=ts"
export * from "./AppLauncherInitializer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.31_css-loader@7.1.4_webpack@5.105.4__ejs@3.1.1_2b44014b4fd9621a31f42a6f593c0737/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports